export default __webpack_public_path__ + "static/media/sara.19bb6289.png";